module.exports = __webpack_public_path__ + "devProcess.98a6470278d3d09a27ab.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/decorativeElements/devProcess.png
// module id = ../../../../../src/assets/decorativeElements/devProcess.png
// module chunks = 0